import { useState, useEffect } from 'react';

interface CookieBannerProps {
  onAccept: () => void;
  onDecline: () => void;
}

export default function CookieBanner({ onAccept, onDecline }: CookieBannerProps) {
  // Rendered in the prerendered HTML so it paints immediately; visitors who
  // already chose never see it (the inline script in index.html hides it before
  // first paint and this effect then removes it).
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (localStorage.getItem('cookieConsent')) {
      setIsVisible(false);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    onDecline();
  };

  if (!isVisible) return null;

  return (
    <section
      data-cookie-banner
      aria-label="Cookievoorkeuren"
      className="on-dark fixed bottom-0 left-0 w-full md:bottom-6 md:left-6 md:w-[26rem] bg-text-main text-surface p-5 md:p-6 z-[100] shadow-2xl"
    >
      <div className="flex flex-col gap-5">
        <p className="text-sm leading-relaxed">
          We gebruiken analyse- en marketingcookies (o.a. Google en Meta) om onze website en advertenties te verbeteren.{' '}
          Lees meer in onze{' '}
          <a href="/privacy" className="underline hover:text-white">
            Privacy- en cookieverklaring
          </a>
          .
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleDecline}
            className="flex-1 px-4 py-3 text-xs uppercase tracking-widest border border-surface hover:bg-surface hover:text-text-main transition-colors"
          >
            Alles weigeren
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 px-4 py-3 text-xs uppercase tracking-widest bg-primary text-white hover:bg-primary/90 transition-colors"
          >
            Alles accepteren
          </button>
        </div>
      </div>
    </section>
  );
}
